import { z } from 'zod'
import {
  isoDateSchema,
  nullableBoolean,
  nullableNumber,
  nullableString,
} from '../../utils/schema'
import { profileBaseSchema } from '../../schema/profile.schema'

const clientImportSchema = z.object({
  objectId: nullableString,
  createdAt: z.nullable(isoDateSchema),
  clientCount: nullableNumber,
  clientProgressCount: nullableNumber,
  createCallList: nullableBoolean,
  filename: nullableString,
  optIn: nullableBoolean,
  optOut: nullableBoolean,
  tagName: nullableString,
  timeMs: nullableNumber,
  unsubscribe: nullableBoolean,
  user: profileBaseSchema.nullable(),
  status: nullableString,
})

const clientImportDetailBaseSchema = z.object({
  clientImport: clientImportSchema,
  stats: z.object({
    loyaltyPointCount: z.number().nullable(),
    loyaltyPointLifetimeCount: z.number().nullable(),
  }),
})

export { clientImportSchema, clientImportDetailBaseSchema }
